export enum VehicleDistanceEnum {
  LESS_THAN_10000 = 'LESS_THAN_10000',
  BETWEEN_10000_AND_15000 = 'BETWEEN_10000_AND_15000',
  MORE_THAN_15000 = 'MORE_THAN_15000',
}

export const getVehicleDistanceLabel = (value: VehicleDistanceEnum): string => {
  switch (value) {
    case VehicleDistanceEnum.LESS_THAN_10000:
      return $localize`0 - 10 000 km`;
    case VehicleDistanceEnum.BETWEEN_10000_AND_15000:
      return $localize`10 000 - 15 000 km`;
    case VehicleDistanceEnum.MORE_THAN_15000:
      return $localize`Plus de 15 000 km`;
    default:
      return '';
  }
};
